import Vue from 'vue'
import Router from 'vue-router'
// import Brower from '@/utils/Brower'
import { getToken, removeToken } from '@/utils/auth'
import store from "@/store";
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('../views/layout/index.vue'),
      children: [
        {
          path: '/',
          name: 'index',
          component: () => import('../views/homeView/index.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        },
        {
          path: '/aboutUs',
          name: 'aboutUs',
          component: () => import('../views/homeView/aboutUs.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        },
        {
          path: '/joinUs',
          name: 'joinUs',
          component: () => import('../views/homeView/joinUs.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        },
        {
          path: '/blog',
          name: 'blog',
          component: () => import('../views/homeView/blog.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        },
        {
          path: '/faq',
          name: 'faq',
          component: () => import('../views/homeView/faq.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        },
        {
          path: '/blogDetail/:id',
          name: 'blogDetail',
          component: () => import('../views/homeView/blogDetail.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        },
        {
          path: '/blog',
          name: 'blog',
          component: () => import('../views/homeView/blog.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        },
        {
          path: '/privacy',
          name: 'privacy',
          component: () => import('../views/homeView/privacy.vue'),
          meta: {
            title: '',
            keyword: '',
            description: ''
          }
        },
      ]
    },
    {
      path: '/privacyH5',
      name: 'privacyH5',
      component: () => import('../views/homeView/privacyH5.vue'),
      meta: {
        title: '',
        keyword: '',
        description: ''
      }
    },
    {
      path: '/deleteAccount',
      name: 'deleteAccount',
      component: () => import('../views/homeView/deleteAccount.vue'),
      meta: {
        title: '',
        keyword: '',
        description: ''
      }
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { y: 0 }
  }
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

router.beforeEach(async (to, from, next) => {
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js